import { createContext } from 'react';

// Only the response just verified by the mounted route guard is shared with Home.
// Catalog data is never used as authorization or persisted as a bootstrap cache.
export const QrHomeBootstrapContext = createContext(null);
